<template>
  <span>
    <label class="page-label">Stream</label>
    <p style="font-weight: 400px; font-size: 14px; line-height: 21px">
      {{ $t('message.pages.live.enterDataLive') }}
    </p>

    <label class="page-label">URL</label>

    <v-text-field
      v-model="streamUrl"
      :placeholder="$t('message.pages.newLive.streamUrl')"
      class="mb-3"
      outlined
      dense
      readonly
      hide-details
    >
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="primary"
              @click="handleShowLink(streamUrl)"
            >
              mdi-content-copy
            </v-icon>
          </template>
          <span>{{ $t('message.pages.videoEditModal.copyToClipboard') }}</span>
        </v-tooltip>
      </template>
    </v-text-field>

    <label class="page-label">Backup URL</label>
    <v-text-field
      v-model="backupUrl"
      class="mb-3"
      outlined
      dense
      readonly
      hide-details
    >
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="primary"
              @click="handleShowLink(backupUrl)"
            >
              mdi-content-copy
            </v-icon>
          </template>
          <span>{{ $t('message.pages.videoEditModal.copyToClipboard') }}</span>
        </v-tooltip>
      </template>
    </v-text-field>

    <label class="page-label">Live Key - {{ titleKey }}</label>
    <v-text-field
      v-model="streamKey"
      :placeholder="$t('message.pages.newLive.streamKey')"
      class="mb-3"
      outlined
      dense
      readonly
      hide-details
    >
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="primary"
              @click="handleShowLink(streamKey)"
            >
              mdi-content-copy
            </v-icon>
          </template>
          <span>{{ $t('message.pages.videoEditModal.copyToClipboard') }}</span>
        </v-tooltip>
      </template>
    </v-text-field>
  </span>
</template>

<script>
// external imports
import { mapMutations } from 'vuex'
import liveStreamKeyApi from '@/services/liveStreamKeyApi'

// internal imports

// API

// Components

export default {
  name: 'LiveStream',
  components: {
    // ...
  },
  props: {
    propsData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    titleKey: '',
    backupUrl: 'rtmp://rtmp-backup.pandavideo.live/live/',
    list: {
      keys: [],
    },
    // ...
  }),
  mounted() {
    this.loadData()
  },
  computed: {
    streamUrl: {
      get() {
        return this.propsData['streamUrl']
      },
      set(value) {
        this.propsData['streamUrl'] = value
      },
    },
    streamKey: {
      get() {
        return this.propsData['streamKey']
      },
      set(value) {
        this.propsData['streamKey'] = value
      },
    },
    // ...
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleShowLink(value) {
      const i18n = this.$i18next
      let text = 'Error trying coping this. Please coping directly from field'

      if (navigator && navigator.clipboard) {
        text = i18n.t('message.copiedToClipboard')
        navigator.clipboard.writeText(`${value}`)
      }

      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text })
    },

    async loadData() {
      try {
        const { data } = await liveStreamKeyApi.getAllLiveStreamKey()

        this.list.keys = data
        const matchingKey = this.list.keys.find(
          (key) => key.stream_key === this.streamKey
        )
        this.titleKey = matchingKey ? matchingKey.title : null
        this.keyLoading = false
      } catch (err) {
        console.error('e', err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {
  .page-label {
    color: var(--v-primary-base) !important;
  }
}
</style>
